/**
 * Allocation cell unit conversion math (hours ↔ percent), built on
 * `shared/calendar.ts`. Both client and server import via
 * `@shared/allocation` so the wire-shape conversion uses the same
 * deterministic rule on both sides.
 *
 * Cells are stored as bare percent numbers (per ADR-0001). PUT input may
 * supply hours; the server converts to percent using `hoursToPercent` and
 * the assignee's `wl`. Staffing-gap rows (`pid = null`) assume `wl = 100`.
 */
import { WH, parseYmKey, workHoursForMonth, ymKeyOfDate } from "./calendar";
import type { ExtrasList } from "./types";

/** Full-time-equivalent workload percent. Staffing-gap rows assume this. */
export const FTE_WL = 100;

export function whForMonth(ymKey: string, extras: ExtrasList = []): number {
  const parsed = parseYmKey(ymKey);
  if (!parsed) return WH;
  return workHoursForMonth(parsed.y, parsed.m, extras);
}

export function availableHours(wlPercent: number, whMonth: number): number {
  return whMonth * (wlPercent / 100);
}

export function hoursToPercent(hours: number, wlPercent: number, whMonth: number): number {
  const avail = availableHours(wlPercent, whMonth);
  return avail > 0 ? (hours / avail) * 100 : 0;
}

export function percentToHours(percent: number, wlPercent: number, whMonth: number): number {
  return (percent / 100) * availableHours(wlPercent, whMonth);
}

export function currentMonthKeyUtc(): string {
  return ymKeyOfDate(new Date(), "utc");
}
